import { render, staticRenderFns } from "./informazioni.vue?vue&type=template&id=3a57439e&"
import script from "./informazioni.vue?vue&type=script&lang=js&"
export * from "./informazioni.vue?vue&type=script&lang=js&"
import style0 from "./informazioni.vue?vue&type=style&index=0&id=3a57439e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports